import React, { useState, useEffect } from "react";
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import StepOne from "components/MicSetup/StepOne";
import StepTwo from "components/MicSetup/StepTwo";
import StepThree from "components/MicSetup/StepThree";
import StepThreeRecordVoice from "components/MicSetup/StepThreeRecordVoice";
import StepFour from "components/MicSetup/StepFour";
import StepFive from "components/MicSetup/StepFive";
import "assets/css/mic-setup.css";

export default function NewMicSetup({}) {
	const [setupProgress, setSetupProgress] = useState({
		stepOne: true,
		stepTwo: false,
		stepThree: false,
		stepFour: false,
		stepFive: false,
	});
	const [errorMessage, setErrorMessage] = useState("");
	const [selectedMic, setMicSelected] = useState("0");
	const [micSensitivity, setMicSensitivity] = useState(60);
	const [recordedAudio, setRecordedAudio] = useState(null);


	return (
		<div className="siteContent mic-setup p-0">
			<DashboardHeader title="Microphone Setup" />

			<div className="row p-4">
				<div className="col-lg-6 left-column">
					<StepOne
						setupProgress={setupProgress}
						setSetupProgress={setSetupProgress}
						setErrorMessage={setErrorMessage}
					/>

					{setupProgress.stepTwo &&
						<>
							<StepTwo
								setSetupProgress={setSetupProgress}
								selectedMicrophone={selectedMic}
								selectMicrophone={setMicSelected}
							/>

							{setupProgress.stepThree &&
								<>
									<StepThree
										setSetupProgress={setSetupProgress}
										micSensitivity={micSensitivity}
										setMicSensitivity={setMicSensitivity}
										selectedMicrophone={selectedMic}
										key={selectedMic}
									/>

									{setupProgress.stepFour &&
										<>
											<StepFour
												setSetupProgress={setSetupProgress}
											/>

											{setupProgress.stepFive &&
												<StepFive />
											}
										</>
									}
								</>
							}
						</>
					}
				</div>
				<div className="col-lg-6 right-column">
					{setupProgress.stepThree &&
						<StepThreeRecordVoice
							setupProgress={setupProgress}
							setSetupProgress={setSetupProgress}
							recordedAudio={recordedAudio}
							setRecordedAudio={setRecordedAudio}
							key={selectedMic}
						/>
					}
				</div>
			</div>
		</div>
	);
}